import { createContext, useContext } from 'react';
import type { Message } from '~/types/chat';

/**
 * This context store the current message that's being rendered so that components that
 * are rendered as part of the message content can access the current message properties.
 */
const messageContext = createContext<Message | undefined>(undefined);

export function useCurrentMessage() {
  return useContext(messageContext);
}

export const MessageProvider = messageContext.Provider;
